<template>
  <div id="app">
    <div class="d-flex justify-center mx-2 mt-15 w-100" fluid>
      <v-card class="px-2">
        <ValidationObserver ref="form" v-slot="{ handleSubmit }">
          <v-form @submit.prevent="handleSubmit(submitForm)">
            <v-row>
              <v-col cols="12" lg="12" md="12" sm="12" xs="12" class="pb-0">
                <p class="app-title-small text-sm ma-0">
                  Role Management Name
                </p>
                <ValidationProvider
                  v-slot="{ errors }"
                  name="Role Management Name"
                  rules=""
                >
                  <v-text-field
                    v-model="roleName"
                    :error-messages="errors"
                    single-line
                    dense
                    outlined
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
              <v-col cols="12">
                <p class="app-title-small text-sm ma-0">
                  Company
                </p>
                <ValidationProvider
                  v-slot="{ errors }"
                  name="Company"
                  rules=""
                >
                  <v-autocomplete
                    dense
                    v-model="company"
                    :items="companyList"
                    item-text="company_name"
                    item-value="company_id"
                    placeholder="Please Select Company...."
                    :error-messages="errors"
                    outlined
                  ></v-autocomplete>
                </ValidationProvider>
              </v-col>
              <v-divider></v-divider>
              <v-col cols="12" lg="12" md="12" sm="12" xs="12" class="pt-0">
                <v-data-table
                  class="mx-3"
                  striped
                  v-model="selected"
                  :headers="headers"
                  :items="res_menus"
                  disable-sort
                  hide-default-footer
                  :items-per-page="999"
                  item-key="id"
                  show-select
                  loading-text="Loading... Please wait"
                >
                </v-data-table>
              </v-col>
              <v-col cols="12" lg="12" md="12" sm="12" xs="12" class="pt-0">
                <v-alert border="left" type="warning" elevation="1">
                  Please be careful in making roles, please do not make roles
                  arbitrarily
                </v-alert>
              </v-col>
              <v-col cols="12" lg="12" md="12" sm="12" xs="12" class="pt-2">
                <v-btn
                  type="submit"
                  color="#307b54"
                  class="text-center ma-1"
                  width="100%"
                  dark
                  :loading="loading"
                  small
                >
                  <span class="text-capitalize">Update</span>
                </v-btn>
                <v-btn
                  color="#008ef8"
                  @click.prevent="closeSuccessNavigate"
                  class="text-center ma-1"
                  width="100%"
                  dark
                  text
                  small
                >
                  <span class="text-capitalize">Cancel</span>
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </ValidationObserver>
      </v-card>
      <!-- dialog success -->
      <v-dialog v-model="dialog" persistent max-width="350">
        <v-card class="pa-8 pb-10 d-flex flex-column justify-center">
          <v-icon color="green" size="100px">mdi-checkbox-marked-circle</v-icon>
          <v-card-title class="title-card mx-auto text-center"
            >Update Role<br />Success</v-card-title
          >
          <v-card-actions class="pa-0">
            <v-spacer></v-spacer>
            <v-btn
              @click.prevent="closeSuccessNavigate"
              color="green"
              :loading="loading"
              class="mt-3 w-full"
              width="100%"
              dark
            >
              <span class="text-capitalize">Okay</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- dialog failed -->
      <v-dialog v-model="dialog2" persistent max-width="350">
        <v-card class="pa-8 pb-10 d-flex flex-column justify-center">
          <v-icon color="#F32626" size="100px">mdi-alert-circle-outline</v-icon>
          <v-card-title class="title-card mx-auto text-center"
            >Update Role<br />Failed</v-card-title
          >
          <p class="mx-auto">The Code already exists</p>
          <v-card-actions class="pa-0">
            <v-spacer></v-spacer>
            <v-btn
              @click.prevent="dialog2 = false"
              color="green"
              class="mt-3 w-full"
              width="100%"
              dark
            >
              <span class="text-capitalize">Okay</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<script>
import Cookies from "js-cookie";
import { createNamespacedHelpers } from "vuex";
const karyawan = createNamespacedHelpers("masterKaryawan");
export default {
  data() {
    return {
      tab: null,
      company: null,
      dates: [],
      dialog2: false,
      dialog: false,
      errorMessage: null,
      loading: false,
      selected: [],
      roleName: null,
      e1: 1,
      menu_id: [],
      headers: [{ text: "Menu Name", value: "name" }]
    };
  },
  watch: {
    res_roleEdit(newval) {
      this.roleName = newval[0].name_role;
      this.company = newval[0].company_id;
      newval.forEach(data => {
        this.res_menus.forEach(item => {
          if (parseInt(item.id) === parseInt(data.id_menus)) {
            this.selected.push(item);
          }
        });
      });
    }
  },
  computed: {
    ...karyawan.mapState(["res_menus", "res_roleEdit", "companyList"])
  },
  components: {},
  mounted() {
    this.$store.dispatch("masterKaryawan/getCompany");
    this.$store.dispatch("masterKaryawan/getMenus");
    this.$store.commit("masterKaryawan/SET_IDROLE", this.$route.params.id);
    this.$store.dispatch("masterKaryawan/getMasterRoleByid");
  },
  methods: {
    onTagValueChange(e) {
      this.employeeName = e.employee_name;
      this.posisition = e.posisition;
    },
    closeSuccessNavigate() {
      this.dialog = false;
      setTimeout(() => {
        this.$router.push("/role-management/");
      }, 200);
    },
    submitForm() {
      const temp_user = JSON.parse(Cookies.get("userdata_login"));
      // button effect
      this.loading = true;
      this.selected.forEach(item => {
        this.menu_id.push({
          id: item.id
        });
      });
      let param = new FormData();
      param.append("role_name", this.roleName);
      param.append("status", "Active");
      param.append("id_create", temp_user.data.id);
      param.append("menu_id", JSON.stringify(this.menu_id));
      param.append("company_id", this.company);
      this.$store.commit("masterKaryawan/SET_IDROLE", this.$route.params.id);
      this.$store.commit("masterKaryawan/SET_TEMPROLE", param);
      this.$store
        .dispatch("masterKaryawan/updateRole")
        .then(response => {
          const res = response.data;
          if (res.status) {
            this.dialog = true;
            this.loading = false;
          } else {
            this.dialog2 = true;
            this.loading = false;
          }
        })
        .catch(error => {
          const message = error.response.status.message;
          this.errorMessage = message;
          this.dialog2 = true;
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="scss" scope>
tbody tr:nth-of-type(even) {
  background-color: rgb(238, 246, 253);
}

tbody tr:nth-of-type(odd) {
  background-color: rgb(255, 255, 255);
}

.v-data-table-header {
  background-color: rgb(238, 246, 253);
  color: white;
}

.v-data-footer {
  background-color: rgb(255, 255, 255);
}

.theme--light.v-data-table thead tr th {
  color: white;
}
.theme--dark.v-icon {
  color: #000000;
}
.theme--dark.v-icon.v-icon.v-icon--disabled {
  color: rgb(2 2 2 / 31%) !important;
}
</style>
